export default __webpack_public_path__ + "static/media/loading_logo_ipp.284ddc2f.gif";